var React = require('react');

function Maintenance (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.2259 0.0520352L29.2259 2.82104C29.447 2.87209 29.6442 2.99681 29.785 3.17471C29.9259 3.35262 30.002 3.57313 30.0009 3.80004V18C30.0009 26.993 18.4479 31.147 16.3319 31.889C16.2256 31.9264 16.1137 31.9454 16.0009 31.945C15.8879 31.9453 15.7756 31.9263 15.6689 31.889C13.5539 31.144 2 26.976 2 18V3.79997C1.99895 3.57307 2.07509 3.35256 2.21593 3.17465C2.35676 2.99675 2.55391 2.87203 2.775 2.82097L15.7759 0.0520352C15.9241 0.0190319 16.0778 0.0190319 16.2259 0.0520352ZM10.6422 13.6308L9.11438 15.2792L14.9573 21.4286L24.0992 11.0141L22.4426 10.0467L14.7254 16.72L10.6422 13.6308Z"}));
}

Maintenance.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Maintenance;

Maintenance.default = Maintenance;
